import { Button, Box } from '@mui/material';

export function TogglePanelButton(props) {
  const { sx, active, ...rest } = props;

  const boxShadow = active
    ? 'inset 2px 0px 4px rgba(0, 0, 0, 0.25), inset 0px 4px 4px rgba(0, 0, 0, 0.25)'
    : undefined;
  const backgroundColor = active ? 'rgba(98, 151, 73, 0.24)' : 'white';

  return (
    <Button
      data-testid="side-panel-toggle"
      title="Toggle side panel"
      color="inherit"
      variant="contained"
      sx={{
        ...sx,
        position: 'relative',
        width: 36,
        height: 36,
        p: 0,
        minWidth: 0,
        backgroundColor,
        boxShadow,
        '&:hover': { boxShadow, backgroundColor },
      }}
      {...rest}
    >
      <Widget
        disabled={props.disabled}
        left="25%"
        right="43%"
        top="25%"
        bottom="51%"
      />
      <Widget
        disabled={props.disabled}
        left="25%"
        right="43%"
        top="54%"
        bottom="25%"
      />
      <Widget
        disabled={props.disabled}
        left="62%"
        right="25%"
        top="25%"
        bottom="25%"
      />
    </Button>
  );
}

function Widget(sx) {
  return (
    <Box
      sx={{
        position: 'absolute',
        backgroundColor: `rgba(0, 0, 0, 0.5)`,
        ...sx,
      }}
    />
  );
}
